<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Mo0ZuO/tc-custom/9781460363263.jpg?1705766094041" alt="This image is the cover for the book Lethal Lies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lethal Lies
      </h1>
      <p class="bookDescription body article font2">
        <p>Chelsea Logan never gets the chance to file the storythat would have shocked the blue-collar town ofSerenity, Maine, to its core. Her death is ruled asuicide, but her cousin Faith Pelletier knows Chelseabetter than that. Faith returns to their hometown andbegins to ask questionsquestions that no one wantsto answer. And it’s not long before she uncovers somenasty little truths about life in this fading mill town.<br/><br/>As Faith closes in on a web of drugs and violence,she is forced to turn to police chief Ty Savage forinformation. After all these years he still gets underher skin, but should she trust him? As the circle ofdeceit draws ever tighter, Faith must outwit a facelessenemy who will stop at nothing to have her silenced.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laurie Breton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e700ce2